<template>
  <div class="verify-form">
    <div style="font-size: 24px; color: #333333; margin-bottom: 30px">
      绑定邮箱
    </div>
    <form @submit.prevent="handleSubmit" v-if="isTrue">
      <!-- 手机号输入框 -->
      <div class="form-group">
        <label for="phone">邮箱地址：</label>
        <input
          type="tel"
          id="phone"
          v-model="form.phone"
          placeholder="请输入邮箱地址"
          @blur="validatePhone"
          :class="{ error: formErrors.phone }"
        />
      </div>
      <span class="error-message">{{ formErrors.phone }}</span>
      <!-- 图形验证码 -->
      <div class="form-group">
        <label for="graphCode">图形验证码：</label>
        <div class="code-input-group">
          <input
            type="text"
            id="graphCode"
            v-model="form.graphCode"
            placeholder="请输入图形验证码"
            @blur="validateGraphCode"
            :class="{ error: formErrors.graphCode }"
          />
          <div class="graph-code-img" @click="refreshGraphCode">
            <img
              :src="graphCodeUrl"
              alt="图形验证码"
              @error="refreshGraphCode"
            />
          </div>
        </div>
      </div>
      <span class="error-message">{{ formErrors.graphCode }}</span>
      <!-- 手机验证码 -->
      <div class="form-group">
        <label for="smsCode">邮箱验证码：</label>
        <div class="code-input-group">
          <input
            type="text"
            id="smsCode"
            v-model="form.smsCode"
            placeholder="请输入邮箱验证码"
            @blur="validateSmsCode"
            :class="{ error: formErrors.smsCode }"
          />
          <button
            type="button"
            class="send-code-btn"
            @click="sendSmsCode"
            :disabled="isSending || !canSendCode"
          >
            {{ isSending ? `${countdown}s后重新发送` : "发送动态验证码" }}
          </button>
        </div>
      </div>
      <span class="error-message">{{ formErrors.smsCode }}</span>
      <div class="form-group submit-group">
        <label>&nbsp;</label>
        <!-- 占位label保持对齐 -->
        <button type="submit" class="submit-btn">提交</button>
      </div>
    </form>
    <div v-else>
      <div class="bindPhone">
        <div>
          <img
            src="@/assets/img/personal/yxbd.png"
            style="width: 80px; margin-right: 20px"
            alt=""
          />
        </div>
        <div>
          <div>已绑定邮箱</div>
          <div style="font-size: 16px; font-weight: bold">
            {{ emailText }}
          </div>
        </div>
      </div>
      <div style="margin-top: 20px">
        <button type="primary" class="submit-btn" @click="changePhone">
          更换邮箱号
        </button>
        <!-- <button type="" class="putong-btn" @click="clearPhone">
          解绑手机号
        </button> -->
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/api/request";
export default {
  data() {
    return {
      emailText: "",
      form: {
        phone: "",
        graphCode: "",
        smsCode: "",
      },
      formErrors: {
        phone: "",
        graphCode: "",
        smsCode: "",
      },
      graphCodeUrl: "", // 图形验证码图片地址
      isSending: false, // 是否正在发送验证码
      countdown: 60, // 倒计时秒数
      timer: null, // 倒计时计时器
      userInfo: {},
      isTrue: false,
    };
  },
  computed: {
    // 判断是否可以发送验证码（手机号和图形验证码都有效）
    canSendCode() {
      return (
        this.form.phone &&
        this.form.graphCode &&
        !this.formErrors.phone &&
        !this.formErrors.graphCode
      );
    },
  },
  created() {
    // 初始化图形验证码
    this.refreshGraphCode();
    this.userInfo = {
      ...JSON.parse(localStorage.getItem("accountInfo"))?.data,
    };
    if (localStorage.getItem("email")) {
      this.emailText = localStorage.getItem("email");
    } else {
      this.emailText = this.userInfo.email;
    }

    if (!this.userInfo.email) {
      this.isTrue = true;
    }
  },
  beforeDestroy() {
    // 清除计时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    validAccount() {
      console.log(this.form);
      request({
        url: `/api/user/contact/valid`,
        method: "post",
        data: {
          email: this.form.phone,
          way: "email",
          validateCode: this.form.graphCode,
        },
      })
        .then((res) => {})
        .catch((error) => {});
    },
    sendCode() {
      request({
        url: `/api/auth/retrieve/captcha`,
        method: "post",
        data: {
          way: "email",
        },
      })
        .then((res) => {
          // this.isTrue = true;
        })
        .catch((error) => {});
    },
    changePhone() {
      this.isTrue = true;
    },
    // 刷新图形验证码
    refreshGraphCode() {
      // // 实际项目中这里应该是后端接口，添加随机数防止缓存
      // this.graphCodeUrl = `/api/captcha?random=${Math.random()}`
      // // 这里使用占位图示例，实际项目中替换为真实接口
      // if (process.env.NODE_ENV === 'development') {
      //   this.graphCodeUrl = `https://picsum.photos/100/40?random=${Math.random()}`
      // }
      request("/api/auth/captcha/img", { responseType: "blob" })
        .then((res) => {
          this.graphCodeUrl = URL.createObjectURL(res);
        })
        .catch((error) => {});
    },

    // 发送手机验证码
    sendSmsCode() {
      // 再次验证表单
      const isPhoneValid = this.validatePhone();
      const isGraphCodeValid = this.validateGraphCode();

      if (!isPhoneValid || !isGraphCodeValid) {
        return;
      }

      this.isSending = true;

      // 模拟发送验证码请求
      setTimeout(() => {
        this.validAccount();
        // 实际项目中这里是后端接口调用
        console.log("发送验证码到:", this.form.phone);
        console.log("图形验证码:", this.form.graphCode);

        // 启动倒计时
        this.startCountdown();
      }, 1000);
    },

    // 启动倒计时
    startCountdown() {
      this.countdown = 60;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.isSending = false;
          this.timer = null;
        }
      }, 1000);
    },

    // 验证手机号
    validatePhone() {
      const phone = this.form.phone.trim();

      if (!phone) {
        this.formErrors.phone = "请输入邮箱号";
        return false;
      } else {
        this.formErrors.phone = "";
        return true;
      }
    },

    // 验证图形验证码
    validateGraphCode() {
      const graphCode = this.form.graphCode.trim();

      if (!graphCode) {
        this.formErrors.graphCode = "请输入图形验证码";
        return false;
      } else if (graphCode.length < 4) {
        // 假设图形验证码是4位
        this.formErrors.graphCode = "图形验证码格式不正确";
        return false;
      } else {
        this.formErrors.graphCode = "";
        return true;
      }
    },

    // 验证手机验证码
    validateSmsCode() {
      const smsCode = this.form.smsCode.trim();

      if (!smsCode) {
        this.formErrors.smsCode = "请输入邮箱验证码";
        return false;
      } else {
        this.formErrors.smsCode = "";
        return true;
      }
    },

    // 整体表单验证
    validateForm() {
      const isPhoneValid = this.validatePhone();
      const isGraphCodeValid = this.validateGraphCode();
      const isSmsCodeValid = this.validateSmsCode();

      return isPhoneValid && isGraphCodeValid && isSmsCodeValid;
    },

    // 提交表单
    handleSubmit() {
      console.log(this.validateForm());
      if (this.validateForm()) {
        // this.validAccount();

        // 表单验证通过，提交数据
        request({
          url: `/api/user/contact/bind`,
          method: "post",
          data: {
            way: "email",
            validateCode: this.form.smsCode,
          },
        })
          .then((res) => {
            // this.sendCode()
            this.$message.success(res?.msg);
            this.isTrue = false;
            localStorage.setItem("email", this.form.phone);
            this.emailText = this.form.phone;
          })
          .catch((error) => {});
      }
    },
  },
};
</script>

<style scoped>
.putong-btn {
  padding: 10px 20px;
  background-color: #ffffff;
  color: black;
  border: 1px solid #b8ccf8;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin-left: 20px;
}

.putongt-btn:hover {
  background-color: #ffffff;
}
.bindPhone {
  background: #f6f8fc;
  padding: 20px;
  display: flex;
  align-items: center;
  border-radius: 4px;
}
.verify-form {
  max-width: 700px;
  padding: 20px; /* 只保留上下内边距 */
  height: 600px;
}

h3 {
  color: #333;
  margin: 0 0 20px 0; /* 移除居中，只保留底部间距 */
  font-size: 18px;
}

.form-group {
  margin-bottom: 5px;
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

label {
  width: 100px;
  text-align: right;
  margin-right: 15px;
  color: #666;
  font-size: 14px;
  flex-shrink: 0; /* 防止label被压缩 */
}

input {
  flex-grow: 1; /* 输入框占剩余空间 */
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

input.error {
  border-color: #ff4d4f;
}

.error-message {
  display: block;
  /* margin-top: 5px; */
  margin-left: 115px; /* 与label+间距宽度一致，保持对齐 */
  color: #ff4d4f;
  font-size: 12px;
  height: 16px;
}

.code-input-group {
  display: flex;
  gap: 10px;
  flex-grow: 1; /* 让整个输入组占满剩余空间 */
}

.graph-code-img {
  width: 120px;
  height: 42px;
  cursor: pointer;
  overflow: hidden;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.graph-code-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.send-code-btn {
  min-width: 120px;
  padding: 0 10px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  height: 42px; /* 与输入框高度一致 */
}

.send-code-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.submit-btn {
  padding: 10px 20px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.submit-btn:hover {
  background-color: #096dd9;
}
</style>
